export { default } from "./redirect.svelte";
